var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-list-wrapper"},[_c('Subtitle',[_vm._v(_vm._s(_vm.title))]),_c('ul',{staticClass:"info-list"},_vm._l((_vm.list),function(ref){
var target = ref.target;
var callback = ref.callback;
var collbackTarget = ref.collbackTarget;
var text = ref.text;
var type = ref.type;
return _c('li',{key:text,staticClass:"info-list-item"},[(type === 'button')?_c('button',{staticClass:"info-list-button",attrs:{"id":collbackTarget},on:{"click":function($event){return _vm.handleListItemClick(target, callback, collbackTarget)}}},[_vm._v("\n        "+_vm._s(text)+"\n      ")]):_c('b-btn',{staticClass:"info-list-button",attrs:{"to":target}},[_vm._v(_vm._s(text))])],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }